import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { NullableType } from '@/types'
import type {
  DictionarieState,
  DocumentProps,
  FuelProps,
  OptionProps,
} from './types'

const initialState: DictionarieState = {
  tsOption: null,
  fuel: {
    typeFuel: {} as OptionProps,
    valueFuel: 0,
  },
  documents: [],
  modelName: '',
  cardModelVehicle: {
    name: '',
  },
  brand: {} as OptionProps,
}

export const dictionarieSlice = createSlice({
  name: 'dictionarie',
  initialState,
  reducers: {
    setTSOption(state, action: PayloadAction<NullableType<OptionProps>>) {
      state.tsOption = action.payload
    },
    setFuel(state, action: PayloadAction<FuelProps>) {
      state.fuel = action.payload
    },
    setDocument(state, action: PayloadAction<DocumentProps>) {
      state.documents.push(action.payload)
    },
    removeDocument(state, action: PayloadAction<number[]>) {
      const { payload } = action
      state.documents = state.documents.filter(
        (item) => !payload.includes(item.id)
      )
    },
    removeAllDocument(state) {
      state.documents = []
    },
    setModelName(state, action: PayloadAction<string>) {
      state.modelName = action.payload
    },
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setCardModelVehicle(state, action: PayloadAction<any>) {
      state.cardModelVehicle = action.payload
    },
    setBrand(state, action: PayloadAction<OptionProps>) {
      state.brand = action.payload
    },
  },
})

export const {
  setTSOption,
  setFuel,
  setDocument,
  removeDocument,
  setModelName,
  setCardModelVehicle,
  setBrand,
  removeAllDocument,
} = dictionarieSlice.actions
